// Footer.js
import React from 'react';

const Footer = () => (
    <footer className="items-center justify-center bg-gradient-to-r from-blue-900 to-purple-900 p-4 text-white shadow-lg opacity-90">
        <p>&copy; 2025 UTA CTF Playground. All rights reserved.</p>
    </footer>
);

export default Footer;
